import Immutable, { Record, List } from 'immutable';

import Ability from './Abilities';
import SubSkill from './SubSkills';
import TargetLanguageCategory from './TargetLanguageCategories';

const SkillRecord = Record({
  skillId: undefined,
  name: undefined,
  fullMark: undefined,
  description: undefined,
  expectation: undefined,
  isRubric: undefined,
  abilities: new List(),
  subSkills: new List(),
  targetLanguageCategories: new List(),
});

class Skill extends SkillRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'skillId':
      return [key, `${val}`];
    case 'abilities':
      return [key, new List(val.map(Ability.create))];
    case 'subSkills':
      return [key, new List(val.map(SubSkill.create))];
    case 'targetLanguageCategories':
      return [key, new List(val.map(TargetLanguageCategory.create))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

Skill.create = (data) =>
  new Skill(data).mapEntries(reviver);

export default Skill;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/model.js